import axios from 'axios'

export const baseURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_STAGE}`
// GraphQL Axios Instance
export const slsAxios = axios.create({ baseURL })
